// extracted by mini-css-extract-plugin
export default {"wrap":"sV-z","articleImagesWrap":"tV-z","articleImage":"uV-z","singleImage":"vV-z"};